module.exports = __webpack_public_path__ + "static/media/universal-logo.832009b4.svg";